export type CategoryGenre =
  'webtoon' | 'bl_webtoon' |
  'romance_serial' | 'fantasy_serial' | 'bl_webnovel' | 'bl_serial' |
  'romance' | 'fantasy' | 'bl_novel' | 'bl' | 'general' |
  'comic' | 'bl_comic' |
  'lightnovel';

export interface V2Category {
  category_id: number;
  name: string;
  genre: CategoryGenre;
  parent_id: number;
  priority?: number;
}

export interface V2Cover {
  small: string;
  large: string;
  xxlarge: string;
}

export interface V2WaitForFree {
  interval_hours: number;
  rental_days: number;
  last_restricted_episodes: number;
  next_available_date?: string;
}

export interface V2Serial {
  serial_id: string;
  title: string;
  cover: V2Cover;
  wait_for_free: V2WaitForFree;
}

export interface V2Book {
  book_id: string;
  title: string;
  cover: V2Cover;
  categories: V2Category[];
  serial?: V2Serial;
  adults_only: boolean;
}

export interface V2ResponseFail {
  success: false;
  message: string;
}

export interface V2ResponseSuccess<R> {
  success: true;
  data: R;
};

export type V2Response<R> = V2ResponseFail | V2ResponseSuccess<R>;

export const isV2ResponseSuccess = (response: V2Response<unknown>): response is V2ResponseSuccess<unknown> => {
  return response.success;
}

export interface LinkedMappedCategory {
  category_id: number;
  text: string;
}

export interface LinkedAnimation {
  laftel_id: number;
  title: string;
  cover: string;
}

export interface LinkedBook extends V2Book {
  extra_book_metadata: {
    mapped_category: LinkedMappedCategory;
  }
}

export type LinkedContent = LinkedAnimation | LinkedBook;
export const isAnimationContent = (content: LinkedContent): content is LinkedAnimation => {
  const laftelId = (content as LinkedAnimation).laftel_id;
  return laftelId !== null && laftelId !== undefined;
}

export type LinkedContentsResponse = V2Response<{
  linked_contents?: {
    books: LinkedBook[];
    animations: LinkedAnimation[]
  }
}>;



// WEBPACK FOOTER //
// ./pages/bookDetail/types.ts